import { computed } from "vue";
import { get } from "lodash-es";
import { useNuxtApp } from "#app";
import { useMainStore } from "@/composables/store";
import { resolveSiteTemplate } from "@/templates/_core/getCurrentTemplate";

export function useSiteTemplate() {
  const store = useMainStore();
  const { $nowCurrentServer } = useNuxtApp();

  const currentSiteInfo = computed(() => store.getSiteInfo() || {});

  const currentStoreInfo = computed(() => {
    return store.getStoreInfoDataMap($nowCurrentServer.value) || {};
  });

  const currentStorePageInfo = computed(() => {
    return get(currentStoreInfo.value, "storePageInfo", {}) || {};
  });

  const templateContext = computed(() => {
    return {
      ...currentStoreInfo.value,
      ...currentStorePageInfo.value,
    };
  });

  const siteTemplate = computed(() => {
    return resolveSiteTemplate(currentSiteInfo.value, templateContext.value);
  });

  const templateKey = computed(() => siteTemplate.value.templateKey);
  const defaultLocale = computed(() => siteTemplate.value.defaultLocale);
  const defaultCurrency = computed(() => siteTemplate.value.defaultCurrency);
  const checkout = computed(() => siteTemplate.value.checkout || {});
  const resources = computed(() => siteTemplate.value.resources || {});
  const pages = computed(() => siteTemplate.value.pages || {});
  const sections = computed(() => siteTemplate.value.sections || {});

  function resolvePage(pageKey) {
    return pages.value?.[pageKey] || null;
  }

  function resolveSection(sectionKey) {
    return sections.value?.[sectionKey] || null;
  }

  return {
    currentSiteInfo,
    currentStoreInfo,
    currentStorePageInfo,
    templateContext,
    siteTemplate,
    templateKey,
    defaultLocale,
    defaultCurrency,
    checkout,
    resources,
    pages,
    sections,
    resolvePage,
    resolveSection,
  };
}

export default useSiteTemplate;
